export default __webpack_public_path__ + "static/jay-phelps-7fd19c8bfa0b7022256e283bbc74ecfa.jpeg";